<template>
  <div class="TopBar">
    <div class="box">
      <div class="bottom">
        <div class="lang">
          <span :class="active==='en'?'active':''"
                @click="changeLang('en')">EN </span>/<span :class="active==='zh'?'active':''"
                @click="changeLang('zh')"> 中文</span>
        </div>
        <!-- <div class="search">
          <input type="text">
        </div> -->
      </div>
      <div class="menu"
           :class="active==='en'?'en':''">
        <span v-for="(item,index) in menuList"
              @click="toNextPage(item.url)"
              :class="{'active':routeUrl.includes(item.sign)}"
              :key="index">
          {{active==='en'?item.entitle:item.title}}
        </span>
      </div>

    </div>
  </div>
</template>

<script>
import Bus from '@/utils/bus.js'
export default {
  name: 'TopBar',
  data () {
    return {
      menuList: [
        {
          title: '触及我们',
          url: '/Contactus',
          sign: '/Contactus',
          entitle: 'Contact Us'
        },
        {
          title: '品质之盾',
          url: '/Qualityshield',
          sign: '/Qualityshield',
          entitle: 'Case Studies'
        },
        {
          title: '经典案例',
          url: '/Classiccase',
          sign: '/Classiccase',
          entitle: 'CEC Services'
        },
        {
          title: '教育推荐',
          url: '/Educational/List',
          sign: '/Educational',
          entitle: 'Our Partners'
        },
        {
          title: '学业增值',
          url: '/Academicvalue',
          sign: '/Academicvalue',
          entitle: 'UK School Life'
        },
        {
          title: '学业规划',
          url: '/Planning',
          sign: '/Planning',
          entitle: 'About CEC'
        }
      ],
      active: window.sessionStorage.getItem('lang') === null ? 'zh' : window.sessionStorage.getItem('lang')
    }
  },
  computed: {
    routeUrl () {
      return this.$route.path
    }
  },
  methods: {
    toNextPage (url) {
      this.$router.push(url)
    },
    changeLang (lang) {
      this.active = lang
      Bus.$emit('langChange', lang)
      window.sessionStorage.setItem('lang', lang)
    }
  }
}
</script>

<style lang="scss" scope>
@import "@/styles/function.scss";
.TopBar {
  flex: 1;
  min-width: 0;
  // padding-bottom: px(35);
  padding-top: px(99);
  margin-right: px(73);
  padding-right: px(133);
  background-color: #fff;
  .box {
    width: 100%;
    & > div.menu {
      &.en {
        & > span {
          font-size: px(14);
          margin-left: px(55);
          &:last-child {
            margin-left: 0;
          }
        }
      }
      &::after {
        display: block;
        content: "";
        clear: both;
      }
      & > span {
        cursor: pointer;
        display: block;
        float: right;
        height: px(20);
        font-size: px(20);
        font-weight: 600;
        color: rgba(185, 143, 109, 1);
        line-height: px(20);
        margin-left: px(77);
        &.active {
          color: #572433;
        }
        &:hover {
          color: #572433;
        }
      }
    }
    & > div.bottom {
      margin-bottom: px(27);
      display: flex;
      justify-content: flex-end;
      .search {
        width: px(211);
        height: px(41);
        background: url(../../static/image/search.png) center no-repeat;
        background-size: 100% 100%;
        input {
          display: block;
          background-color: rgba(0, 0, 0, 0);
          font-size: px(20);
          outline: none;
          border: none;
          padding: px(10);
          width: px(150);
          color: #fff;
        }
      }
      .lang {
        display: flex;
        align-items: center;
        // margin-right: px(53);\
        cursor: pointer;
        font-size: px(17);
        font-weight: 600;
        color: rgba(185, 143, 109, 1);
        line-height: px(20);
        & > span {
          display: block;
          margin: 0 px(5);
          &.active {
            color: #572433;
          }
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TopBar.vue